// src/pages/b2b/B2BSurveyResponsesPage.js - 응답 결과 페이지 (더미)

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import B2BLayout from '../../components/b2b/B2BLayout';
import { usePageHeader } from '../../context/PageHeaderContext';
import './B2BSurveyResponsesPage.scss';

const B2BSurveyResponsesPage = () => {
  const { studySlug } = useParams();
  const navigate = useNavigate();

  usePageHeader({
    title: '응답 결과',
    subtitle: '수집된 응답 데이터를 확인하고 분석하세요',
    showBack: true,
    onBack: () => navigate(`/b2b/study/${studySlug}`),
  });

  return (
    <B2BLayout hideCollapseButton={false} defaultCollapsed={true}>
      <div className="b2b-survey-responses-page">
        <div className="b2b-page-content">
          <div className="b2b-placeholder">
            <p>준비 중입니다...</p>
          </div>
        </div>
      </div>
    </B2BLayout>
  );
};

export default B2BSurveyResponsesPage;

